module.exports = __webpack_public_path__ + "img/mapE.64bc360f.jpg";